<template>
  <section class="invoice-preview-wrapper">
    <b-row class="invoice-preview">
      <b-col cols="12" xl="9" md="8" v-if="loading">
        <b-skeleton animation="wave" width="100%" height="350px" />
      </b-col>
      <b-col cols="12" xl="9" md="8" v-else>
        <b-card no-body class="invoice-preview-card">
          <b-card-body class="invoice-padding pb-0">
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
            >
              <div>
                <div class="mr-auto">
                  <b-link
                    class="navbar-brand d-flex align-items-center mb-3"
                    to="/"
                  >
                    <span class="brand-logo" style="height: 40px">
                      <b-img
                        :src="appLogoImage"
                        fluid
                        alt="logo"
                        style="max-height: 40px"
                      />
                    </span>
                    <h4 class="brand-text mb-0 ml-1">{{ appName }}</h4>
                  </b-link>
                </div>
              </div>

              <div class="mt-md-1 mt-3">
                <h4 class="invoice-title">
                  شناسه فاکتور
                  <span class="invoice-number"> #{{ $route.params.id }} </span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">تاریخ صدور:</p>
                  <p class="invoice-date">
                    {{ calcDate(invoice.created_at) }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <hr class="invoice-spacing" />

          <b-card-body class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <b-col cols="12" xl="6" class="p-0">
                <h6 class="mb-2">اطلاعات خریدار:</h6>
                <h6 class="mb-50">
                  <feather-icon icon="UserIcon" />
                  {{ invoice.user.first_name + " " + invoice.user.last_name }}
                </h6>
                <p class="card-text mb-50">
                  <feather-icon icon="PhoneIcon" /> {{ invoice.user.mobile }}
                </p>
                <p class="card-text mb-50">
                  <feather-icon icon="MailIcon" /> {{ invoice.user.email }}
                </p>
              </b-col>

              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div class="w-50">
                  <h6 class="mb-2">اطلاعات پرداخت:</h6>
                  <div class="">
                    <div class="d-flex flex-wrap">
                      <p class="invoice-total-title">جمع تخفیف :</p>
                      <span class="font-weight-bold text-danger ml-2">
                        {{ Number(invoice.amount) - invoice.final_amount }}
                        تومان
                      </span>
                    </div>
                    <hr class="my-50" />
                    <div class="d-flex flex-wrap">
                      <p class="invoice-total-title">جمع مبلغ :</p>
                      <h6 class="font-weight-bold text-success mb-0 ml-2">
                        {{ invoice.final_amount }} تومان
                      </h6>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <b-table-lite responsive :items="items" :fields="fields">
            <template #cell(id)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{ data.item.model.id }}
              </b-card-text>
            </template>
            <template #cell(name)="data">
              <template v-if="data.item.model_type == 'penalty'">
                <div>دوره : {{ data.item.model.course.name }}</div>
                <div class="my-50">
                  جلسه : {{ data.item.model.session.name }}
                </div>
                <div>تمرین : {{ data.item.model.exercise.title }}</div>
              </template>
              <template v-else>
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.model.name }}
                </b-card-text>
              </template>
            </template>
            <template #cell(type)="data">
              <b-card-text class="font-weight-bold mb-25">
                {{
                  data.item.model_type == "penalty"
                    ? "جریمه"
                    : data.item.model_type == "course"
                    ? "دوره"
                    : "ترم"
                }}
              </b-card-text>
            </template>
            <template #cell(active)="data">
              <b-card-text
                v-if="data.item.model_type != 'penalty'"
                :class="[
                  'font-weight-bold mb-25',
                  data.item.model.active ? 'text-success' : 'text-danger',
                ]"
              >
                {{ data.item.model.active ? "فعال" : "غیر فعال" }}
              </b-card-text>
              <span v-else>-</span>
            </template>
          </b-table-lite>
        </b-card>
      </b-col>

      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            پرینت فاکتور
          </b-button>

          <b-button
            v-b-toggle.sidebar-invoice-add-payment
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-75"
            block
            v-if="invoice.status == 0"
            :to="{
              name: 'checkout',
              query: { invoice_id: $route.params.id },
            }"
          >
            پرداخت
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BSkeleton,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { $themeConfig } from "@themeConfig";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      appLogoImage: $themeConfig.app.appLogoImage,
      appName: $themeConfig.app.appName,
      items: [],
      invoice: {},
      loading: false,
      fields: [
        { key: "id", label: "شناسه" },
        { key: "name", label: "" },
        { key: "type", label: "نوع" },
        { key: "active", label: "وضعیت" },

        // { key: "available_at", label: "زمان شروع" },
        // { key: "unavailable_at", label: "زمان پایان" },
        // { key: "final_amount", label: "قیمت دوره (تومان)" },
        // { key: "course_count", label: "تعداد دوره" },
        // { key: "status", label: "وضعیت" },
      ],
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    BImg,
    BSkeleton,
  },
  methods: {
    printInvoice() {
      window.print();
    },
    async getInvoice() {
      try {
        const { data } = await this.$http.get(
          `/panel/invoices/${this.$route.params.id}?includes[]=items.model.exercise&includes[]=items.model.session&includes[]=items.model.course&includes[]=user`
        );
        this.invoice = data.data;
        this.items = data.data.items.items;
      } catch (err) {}
    },
    async getItems() {
      await this.items.forEach(async (item, index) => {
        const { data } = await this.$http.get(
          `/panel/${
            item.model_type.includes("semester") ? "semesters" : "courses"
          }/${item.model_id}`
        );
        this.items[index] = await { ...item, ...data.data };
      });
    },
  },
  async created() {
    this.loading = true;
    await this.getInvoice();
    // await this.getItems();
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
